// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__gDJyb","label":"Category_label__3ag4I","content":"Category_content__3cNWd","header":"Category_header__25XOr","location":"Category_location__1Q8oD"};